import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { Avatar } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'

import { isEmptyOrNil } from 'libs/empty'

const useStyles = makeStyles((theme) => ({
  black: {
    backgroundColor: '#071E3D',
  },
  navy: {
    backgroundColor: '#1F4287',
  },
  cyan: {
    backgroundColor: '#0E9CBC',
  },
  purple: {
    backgroundColor: '#7045AF',
  },
  magenta: {
    backgroundColor: '#E14594',
  },
  orange: {
    backgroundColor: '#E18745',
  },
  default: {
    '&.MuiAvatar-colorDefault': {
      color: theme.colors['primary-100'],
      backgroundColor: theme.colors['primary-350'],
    },
    '& .MuiAvatar-fallback': {
      width: ' 100%',
      height: '100%',
    },
  },
}))

const Fallbacks = (props) => {
  const { id, name, characters, className } = props
  const avatarClasses = useStyles()

  const bgColorSet = ['black', 'navy', 'cyan', 'purple', 'magenta', 'orange']

  const getBgClassName = (subId) => {
    return parseInt(subId)
      ? bgColorSet[parseInt(subId) % bgColorSet.length]
      : bgColorSet[0]
  }

  return (
    <Avatar
      {...props}
      alt={name}
      src={characters}
      className={clsx(
        className,
        isEmptyOrNil(characters)
          ? avatarClasses.default
          : avatarClasses[getBgClassName(id)],
      )}
    >
      {characters}
    </Avatar>
  )
}
export default Fallbacks

Fallbacks.propTypes = {
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  characters: PropTypes.string.isRequired,
  className: PropTypes.string,
}
